import { JOURNAL_ENTRY_ACCOUNTING_INTEGRATION_APP_NAME } from '../../settings-apps.domain';

export function getInstalledAppLinkText(appName: string): string {
	if (JOURNAL_ENTRY_ACCOUNTING_INTEGRATION_APP_NAME[appName]) {
		return $.__('Connect Account');
	}

	return $.__('Settings');
}
